import script from "./ChatLayoutPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatLayoutPicker.vue?vue&type=script&setup=true&lang=js"

import "./ChatLayoutPicker.vue?vue&type=style&index=0&id=2765231a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2765231a"]])

export default __exports__